<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`${activeInfo.id ? '编辑' : '新增'}车辆信息`"
    width="900px"
    height="600px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm', 'carTypeOptions')"
  >
    <el-form v-loading="detailLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="12">
          <el-form-item label="车牌号" prop="carNo">
            <el-input v-model.trim="editForm.carNo" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆类型" prop="type">
            <el-select v-model="editForm.type" placeholder="请选择" clearable>
              <el-option v-for="item in carTypeOptions" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="行驶证到期日" prop="driveExpire">
            <el-date-picker
              v-model="editForm.driveExpire"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="年检到期日" prop="checkExpire">
            <el-date-picker
              v-model="editForm.checkExpire"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="保养日期" prop="upkeepTime">
            <el-date-picker
              v-model="editForm.upkeepTime"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="车辆图片" prop="pics">
            <image-upload v-model="editForm.pics" :modelType="2" :paramsData="{ type: 'upt_car_img' }"></image-upload>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="车辆保单文件" prop="files">
            <upload-button v-model="editForm.files" :fileSize="50" :paramsData="{ type: 'upt_file' }"></upload-button>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="editForm.remark" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { getDictsByCode, editCar } from '@/api/system';
import ImageUpload from '@/components/UploadArea/ImageUpload';
import UploadButton from '@/components/UploadArea/UploadButton';

export default {
  components: { ImageUpload, UploadButton },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      detailLoading: false,
      editForm: {},
      carTypeOptions: [],
      rules: {
        carNo: [{ required: true, message: '请输入车牌号', trigger: 'blur' }]
      }
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val && this.activeInfo.id) {
        this.getDetailData();
      }
      if (val && this.carTypeOptions.length == 0) {
        this.getDictsByCode('car_type', 'carTypeOptions');
      }
    }
  },
  methods: {
    getDetailData() {
      const detail = { ...this.activeInfo };

      this.editForm = detail;
    },
    handleSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;

          const params = { ...this.editForm };
          params.pics = JSON.stringify({
            pics: params.pics,
            files: params?.files || []
          });
          delete params.files;
          try {
            await editCar(params);
            this.$emit('refresh');
            this.$emit('update:visible', false);
            this.$message.success('提交成功!');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    },
    async getDictsByCode(code, dataType) {
      const { data } = await getDictsByCode({ code });
      this[dataType] = data ?? [];
    }
  },
  created() {},
  mounted() {}
};
</script>

<style scoped>
.el-select {
  width: 100%;
}

.el-button--mini.is-circle {
  padding: 5px;
}
</style>
